const SuccessLayout = () => {
    return (
        <div className="page-success-layout">
            <div className="page-success-modal">
                <img
                    className="success-icon"
                    src={
                        require('../../assets/images/icons/success-icon.svg')
                            .default
                    }
                    alt=""
                />
                <p>Payment Successful</p>
            </div>
        </div>
    )
}
export default SuccessLayout
